import { IconButton } from 'ui-components/src/components/atoms/IconButton';
import styled from 'styled-components';
import { SimpleArrow } from 'ui-components/src/components/atoms/icons';

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const NestedList = styled.ul`
  list-style: none;
  padding: 0 0 0.5rem 1rem;
  margin: 0;
  margin-left: 1rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0rem;
    bottom: 1rem;
    width: 1px;
    background-color: #0693ca;
  }
`;

export const FolderItem = styled.li`
  border-bottom: 1px solid rgb(224, 224, 224);
  padding: 0.5rem 0.25rem;

  &:hover {
    background-color: rgb(248, 248, 248);
  }
  &:last-child {
    border-bottom: none;
    padding: 0.25rem 0.25rem;
  }
`;

export const FolderButton = styled.button`
  width: 100%;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.25rem;
  text-align: left;
  cursor: pointer;
  color: inherit;
  font: inherit;
`;

export const FolderCaret = styled(SimpleArrow)<{ $collapsed: boolean }>`
  margin-left: auto;
  flex: 0 0 auto;
  height: 13px;
  fill: #0693ca;
  transform: rotate(${({ $collapsed }) => ($collapsed ? '-90deg' : '0deg')});
  transition: transform 0.2s ease;
`;

export const FolderName = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const EmptyState = styled.li`
  padding: 0.5rem 0.25rem;
  font-size: 14px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  > [data-testid='loadable-view'] {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const StyledIconButton = styled(IconButton)`
  position: relative;
  justify-content: center;
  margin-top: auto;
  flex-shrink: 0;

  > div {
    flex: initial;
  }
`;
